import { documentId, limit, orderBy, query, where } from 'firebase/firestore'
import { ArrayService } from './serviceLive'
import type { Task } from '~/models/Task'
import {
  PrescriptionAttachmentTaskStatus,
  TaskStatus,
  TaskType,
} from '~/models/Task'

export class TaskService extends ArrayService<Task> {
  constructor() {
    super('Tasks')
  }

  public listenForId(id: string): void {
    const listenQuery = query(this.collection, where(documentId(), '==', id))
    this.listen(listenQuery)
  }

  public listenForUserId(userId: string): void {
    const listenQuery = query(this.collection, where('UserId', '==', userId))
    this.listen(listenQuery)
  }

  public listenForOpenPrescriptionAttachmentTasks(): void {
    const listenQuery = query(
      this.collection,
      where('Type', '==', TaskType.PrescriptionAttachment),
      where(
        'TaskData.Status',
        '!=',
        PrescriptionAttachmentTaskStatus.AwaitingProcessing,
      ),
      where('Status', '==', TaskStatus.Pending),
      orderBy('Created', 'desc'),
      limit(100),
    )

    this.listen(listenQuery)
  }
}
